export enum LocationType {
  vide = "vide",
  meuble = "meuble",
  foyer = "foyer",
}

export enum LogementType {
  proprietaire = "proprietaire",
  locataire = "locataire",
  heberge = "heberge",
  sansDomicile = "sansDomicile",
}

export enum StatutOccupationLogement {
  primo_accedant = "primo_accedant",
  proprietaire = "proprietaire",
  locataire_vide = "locataire_vide",
  locataire_meuble = "locataire_meuble",
  loge_gratuitement = "loge_gratuitement",
  locataire_foyer = "locataire_foyer",
  sans_domicile = "sans_domicile",
}
